// Plugin Selection View
export const TEMPLATE = 'template';
export const PLUGIN = 'plugin';
export const PLUGIN_2ND_STEP_PATHWAYS = 'plugin_2nd_step_pathways';
